import { LockKeyhole } from 'lucide-react';
import { useTranslation } from '../../../lib/i18n';
import { useGenericBi } from '../../../lib/use-generic-bi';
import { useActiveConversation } from '../../chat/ActiveConversationContext';
import { Button, Typography } from '../ui';
import styles from './BriefSlot.module.css';

// "Re-enable Agents Morning Meetings" — the slot when the morning-brief routine is paused or was never
// seeded. The CTA opens a chat asking the Maestro to turn it back on, exactly like the native
// `BriefActivateCard`. Figma node 2057:12397 ("Symphony Card Box").

export function ActivateBrief() {
  const { t } = useTranslation();
  const { logPageClickBi } = useGenericBi();
  const { openChatWithMessage } = useActiveConversation();

  return (
    <section className={styles.slot} aria-labelledby="brief-activate-title">
      <p className={styles.eyebrow}>
        <LockKeyhole size={16} aria-hidden />
        <Typography variant="h4" color="strong" component="span">
          {t('brief.activate.eyebrow')}
        </Typography>
      </p>
      <h2 id="brief-activate-title" className={`${styles.title} ${styles.titleFirst}`}>
        {t('brief.activate.title')}
      </h2>
      <Typography variant="h3" component="p" className={styles.body}>
        {t('brief.activate.body')}
      </Typography>
      <div className={styles.actions}>
        <Button
          data-card-primary
          size="medium"
          onClick={() => {
            logPageClickBi({ page_name: 'home', button_name: 'brief_activate' });
            openChatWithMessage({ kind: 'new', message: t('brief.activate.chatMessage') });
          }}
        >
          {t('brief.activate.cta')}
        </Button>
      </div>
    </section>
  );
}
